// NATIVE 


// INSTALLED 


// CUSTOM 
import { setCargosSelectRedux } from '../cargos';
import { setShiftsSelectRedux } from '../shifts/shiftsSlice';
import { checkingPreload, unCheckingPreload } from '../loading';
import { createConfiguracionTurnoService, getAllParametersDataCreateFormService, getConfigShiftEmployeesService } from '../../services/shifts_employees.service';
import { setFrecuencyhiftsSelectRedux, setShiftsEmployeesListRedux, setTypeShiftsSelectRedux } from './shiftsEmployeesSlice';
import { generateScheduleShiftsService } from '../../services/configuration_shifts_employee';









export const getConfigShiftEmployeesStore = (): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        const result = await getConfigShiftEmployeesService();


        if (result.ok) {
            await dispatch( setShiftsEmployeesListRedux(result.data) );
        }

        
        await dispatch( unCheckingPreload() );

        return result;
        

    }

}




export const getDataFormCreateShiftEmployees = (): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        const result = await getAllParametersDataCreateFormService();


        if (result.ok) {
            await dispatch( setCargosSelectRedux(result.data.positions) );
            await dispatch( setTypeShiftsSelectRedux(result.data.typeShifts) );
            await dispatch( setShiftsSelectRedux(result.data.shifts) );
            await dispatch( setFrecuencyhiftsSelectRedux(result.data.frecuencyShifts) );
        }

        
        await dispatch( unCheckingPreload() );

        return result;
        

    }

}



export const storeConfiguracionTurno = (configuracionTurno: any, percentage:any): any => {
    

    return async( dispatch: any ) => { 


        await dispatch( checkingPreload() );
        

        const dataSave = {
            name: configuracionTurno.name,
            auto_generate: configuracionTurno.autoGenerarse,
            cargo: configuracionTurno.cargo.value,
            tipo_turno: configuracionTurno.TipoTurno.value,
            turnos: ( configuracionTurno.turnos.length > 0 ) ? configuracionTurno.turnos.map( (turno:any) => turno.value ): [],
            frecuencia_turnos: configuracionTurno.frecuencia.value,
            sundays_and_holidays: configuracionTurno.domingosyFestivos,
            date_start: configuracionTurno.fechaInicioTurno
        }


        const result = await  createConfiguracionTurnoService(dataSave, percentage);
      

        dispatch( unCheckingPreload() );


        if ( result.ok ) {
            await dispatch( setShiftsEmployeesListRedux(result.data) );
        }


        return result;
        

    }

      
}






export const createConfigShiftEmployeesStore = (id:string, percentage:any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        const result = await generateScheduleShiftsService(id, percentage);


        if (result.ok) {
            await dispatch( setShiftsEmployeesListRedux(result.data) );
        }

        
        await dispatch( unCheckingPreload() );

        return result;
        

    }

}





// export const getSucursalDataSelects = (): any => {

//   return async( dispatch: any ) => {
     

//       await dispatch( checkingPreload() );

//       const result = await  getSucursalDataSelectsService();

//       if ( result.ok ) {


//         await dispatch( setCountrySelectRedux(result.data.pais) );
//         await dispatch( setWorkPlaceSelectRedux(result.data.sitioDeTrabajo) );

//         // PAGOS
//         await dispatch( setBancosSelectRedux(result.data.bancos) );
//         await dispatch( setTypeAccountBankSelectRedux(result.data.tipoCuenta) );

//         // SEGURIDAD SOCIAL 
//         await dispatch( setCajaArlSelectRedux(result.data.arls) );
//         await dispatch( setCajaArlSelectRedux(result.data.arls) );
//         await dispatch( setCajaCompensacionSelectRedux(result.data.cajaCompensacion) );
        
        
        

        
//       }
      
//       dispatch( unCheckingPreload() );

//       return result;


//   }


// }







// export const saveSucursal = (sucursal:any, setPercentajeCSucursal: any): any => {

//     return async( dispatch: any ) => {

//         dispatch( checkingPreload() );

        
//         const data_save = {
//               name: sucursal.sucursal_name,
//               address: sucursal.sucursal_address,
//               country: sucursal.country.value,
//               departament: sucursal.departament.value,
//               municipaly: sucursal.municipaly.value,
//               workplace: sucursal.workplace.value,
//               family_compensation_fund: sucursal.family_fund_compensation.value,
//               landline: sucursal.landline,
//               cell_phone: sucursal.cell_phone,
//               arl: sucursal.arl.value,
//               associated_bank: sucursal.associated_bank.value,
//               type_account_bank: sucursal.type_account_bank.value,
//               account_number: sucursal.account_number,
//               logo: sucursal.logo_sucursal_name_saved_file
//         }

        
//         const result = await saveSucursalService(data_save, setPercentajeCSucursal);

        
        
//        await dispatch( unCheckingPreload() );

//        if ( result.ok ) {
//            await dispatch( setSucursalListRedux(result.data) );
//        }
       
       
//         return result;
        
//     }
// }






// export const editSucursal = (sucursal:any, setPercentajeCSucursal: any): any => {

//     return async( dispatch: any ) => {

//         dispatch( checkingPreload() );

        
//         const data_save = {
//               name: sucursal.e_sucursal_name,
//               address: sucursal.e_sucursal_address,
//               country: sucursal.e_country.value,
//               departament: sucursal.e_departament.value,
//               municipaly: sucursal.e_municipaly.value,
//               workplace: sucursal.e_workplace.value,
//               family_compensation_fund: sucursal.e_family_fund_compensation.value,
//               landline: sucursal.e_landline,
//               cell_phone: sucursal.e_cell_phone,
//               arl: sucursal.e_arl.value,
//               associated_bank: sucursal.e_associated_bank.value,
//               type_account_bank: sucursal.e_type_account_bank.value,
//               account_number: sucursal.e_account_number,
//               logo: sucursal.e_logo_sucursal_name_saved_file,
//               sucursalId: sucursal.sucursalId
//         }

        
//         const result = await editSucursalService(data_save, setPercentajeCSucursal);

        
        
//        await dispatch( unCheckingPreload() );

//     //    if ( result.ok ) {
//     //         await dispatch( setSucursalListRedux(result.data) );
//     //    }
       
       
//         return result;
        
//     }
// }






// export const storeDetailSucursal = (sucursalId: string, percentage:any): any => {
    

//     return async( dispatch: any ) => { 


//         await dispatch( checkingPreload() );
        

//         const result = await  getSucursalDetailService(sucursalId, percentage);
      

//         dispatch( unCheckingPreload() );


//         if ( result.ok ) {
//             await dispatch( setSucursalRedux(result.data) );
//         }


//         return result;
        

//     }

      
// }





// export const storeDesactiveSucursal = (sucursalId: string): any => {
    

//     return async( dispatch: any ) => { 

//         await dispatch( checkingPreload() );
        

//         const result = await  desactiveSucursalService(sucursalId);

        
        
//         dispatch( unCheckingPreload() );

//         if ( result.ok ) {
//             await dispatch( setSucursalListRedux(result.data) );
//         }

//         return result;

//     }

      
// }





// export const storeActiveSucursal = (sucursalId: string): any => {
    

//     return async( dispatch: any ) => { 

//         await dispatch( checkingPreload() );
        

//         const result = await  activeSucursalService(sucursalId);

        
        
//         dispatch( unCheckingPreload() );

//         if ( result.ok ) {
//             await dispatch( setSucursalListRedux(result.data) );
//         }

//         return result;

//     }

      
// }




// export const getSucursalesByPagination = (page:number): any => {

//     return async( dispatch: any ) => {


//       await dispatch( checkingPreload() );
      


//       const result = await  getSucursalesByPaginateService(page);


//       if ( result.ok ) {
//            await dispatch( setSucursalListRedux(result.data) );
//       }
    
//       dispatch( unCheckingPreload() );
      
//       return result;
        
//     }

// }






